import { render } from "./studioInfo.vue?vue&type=template&id=4480457c&scoped=true"
import script from "./studioInfo.vue?vue&type=script&lang=js"
export * from "./studioInfo.vue?vue&type=script&lang=js"

import "./studioInfo.vue?vue&type=style&index=0&id=4480457c&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4480457c"]])

export default __exports__